import { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

// import accordion from "../assets/accordion.png";
import biorecipe from "../assets/file_g.png";
import CELESTA from "../assets/CELESTA.png";
// import clarinet from "../assets/clarinet.png";
import dish from "../assets/dish2.png";
// import flute from "../assets/flute.png";
import violin from "../assets/violin_g.png";
// import motif from "../assets/motif.png";

import kalimba from "../assets/kalimba.png";
import nl2bltl from "../assets/nl2bltl.svg";
// import bell from "../assets/bell.png";
// import gmn from "../assets/gmn.png";
// import Img from "../components/Img";
import bohemeImg from "../assets/boheme.png";

// ── Constants ────────────────────────────────────────────────────────────────

const CURRENT_TOOLS = [
  {
    title: "BioRECIPE",
    image: biorecipe,
    navigateTo: "/biorecipe",
    description:
      "A structured, human- and machine-readable format for biological networks.",
  },
  {
    title: "CELESTA",
    image: CELESTA,
    navigateTo: "/celesta",
    description:
      "A semi-supervised multi-task framework for classification in biomedical texts.",
  },
  {
    title: "NL2BLTL",
    image: nl2bltl,
    navigateTo: "/nl2bltl",
    description:
      "A natural-language interface for temporal logical specification.",
  },

  {
    title: "KALIMBA",
    image: kalimba,
    navigateTo: "/kalimba",
    description: "Knowledge-Assisted & Literature Mining",
  },
  {
    title: "VIOLIN",
    image: violin,
    navigateTo: "/violin",
    description:
      " A modular framework for scalable reconciliation of  interaction graphs.",
  },
  // {
  //   title: "MOTIF",
  //   image: motif,
  //   navigateTo: "/motif",
  //   description:
  //     "Design and simulate gene regulation network motifs with AI-powered biological examples.",
  // },
];

const PIPELINE_TOOLS = [
  {
    title: "DiSH",
    image: dish,
    navigateTo: "/",
    description:
      "A flexible modeling and simulation framework for hybrid elements.",
    comingSoon: true,
  },
];

// ── Breakpoints ───────────────────────────────────────────────────────────────
const bp = {
  mobile: "600px",
  tablet: "900px",
};

// ── Styled Components ────────────────────────────────────────────────────────

// Mobile-only banner — never visible on desktop
const MobileBanner = styled.div`
  display: none;

  @media (max-width: ${bp.tablet}) {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background: #fefce8;
    border-bottom: 2px solid #f59e0b;
    padding: 12px 16px;
    font-size: 0.82rem;
    color: #78350f;
    line-height: 1.5;
    grid-column: 1 / -1;
  }
`;

// const BannerIcon = styled.span`
//   font-size: 1.1rem;
//   flex-shrink: 0;
//   margin-top: 1px;
// `;

const BannerText = styled.div`
  flex: 1;

  strong {
    display: block;
    margin-bottom: 2px;
    font-size: 0.85rem;
  }
`;

const BannerDismiss = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #92400e;
  font-size: 1.1rem;
  padding: 0;
  flex-shrink: 0;
  line-height: 1;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`;

const WelcomeBanner = styled.div`
  grid-column: 1 / -1;
  background: white;
  border-bottom: 1px solid #dde1ec;
  padding: 1.4rem 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: start;
  height: 150px;
  align-items: center;
  text-align: center;

  @media (max-width: ${bp.mobile}) {
    height: auto;
    min-height: 80px;
    padding: 1rem;
  }
`;

// const WelcomeAccent = styled.div`
//   width: 4px;
//   height: 42px;
//   background: #0a2260;
//   border-radius: 2px;
//   flex-shrink: 0;
// `;

// const WelcomeTitle = styled.h1`
//   font-size: 1.4rem;
//   font-weight: 700;
//   color: #0a2260;
//   margin: 0 0 0.2rem;
// `;

// const WelcomeSubtitle = styled.p`
//   font-size: 0.92rem;
//   color: #6b7280;
//   line-height: 1.5;
//   margin: 0;
// `;

const Page = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: auto 1fr;
  min-height: calc(100vh - 120px);
  background: #f0f2f7;
  padding: 0 20rem;
  font-family: Georgia, "Times New Roman", serif;

  @media (max-width: ${bp.tablet}) {
    padding: 0 1.5rem;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto;
  }

  @media (max-width: ${bp.mobile}) {
    padding: 0;
  }
`;

const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 1.75rem 1.25rem;
  background: #f0f2f7;
  border-right: 1px solid #dde1ec;
  align-self: start;

  @media (max-width: ${bp.tablet}) {
    border-right: none;
    border-top: 1px solid #dde1ec;
    padding: 1.25rem 1rem;
    order: 3;
  }

  @media (max-width: ${bp.mobile}) {
    padding: 1rem;
  }
`;

const SideCard = styled.div`
  background: none;
  border-radius: 10px;
  padding: 1.1rem;
  min-width: 280px;

  @media (max-width: ${bp.tablet}) {
    min-width: 0;
  }
`;

const IntroText = styled.p`
  font-size: 1.2rem;
  color: #374151;
  line-height: 1.6;
  margin: 0 0 0.85rem;
  text-align: justify;
  align-items: center;
  text-align: center;

  @media (max-width: ${bp.mobile}) {
    font-size: 1rem;
    margin: 0;
  }
`;

// const DiagramBox = styled.div`
//   width: 100%;
//   aspect-ratio: 4/3;
//   background: linear-gradient(135deg, #e8edf8 0%, #d6dff5 100%);
//   border-radius: 8px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   color: #9ca3af;
//   font-size: 0.72rem;
//   border: 1px dashed #b0bcd8;
// `;

const MainContent = styled.main`
  padding: 1.75rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-self: start;

  @media (max-width: ${bp.tablet}) {
    padding: 1.25rem 1rem;
    order: 2;
  }

  @media (max-width: ${bp.mobile}) {
    padding: 1rem;
  }
`;

const Section = styled.section`
  flex: 1;
`;

const SectionTitle = styled.h2`
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #0a2260;
  margin: 0 0 0.85rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #dde1ec;
`;

const ToolGrid = styled.div`
  display: grid;
  grid-template-columns: ${({ $cols }) => `repeat(${$cols ?? 4}, 1fr)`};
  gap: 1rem;

  @media (max-width: ${bp.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 380px) {
    grid-template-columns: 1fr;
  }
`;

const CardWrapper = styled.div`
  background: white;
  border-radius: 10px;
  padding: 1.1rem 0.85rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: space-between;

  max-width: 220px;
  min-width: 170px;

  cursor: ${({ $comingSoon }) => ($comingSoon ? "default" : "pointer")};
  opacity: ${({ $comingSoon }) => ($comingSoon ? 0.7 : 1)};
  transition:
    transform 0.18s,
    box-shadow 0.18s;
  position: relative;
  max-height: 240px;

  &:hover {
    transform: ${({ $comingSoon }) =>
      $comingSoon ? "none" : "translateY(-2px)"};
    box-shadow: ${({ $comingSoon }) =>
      $comingSoon
        ? "0 1px 4px rgba(0,0,0,0.07)"
        : "0 6px 18px rgba(0,0,0,0.12)"};
  }

  @media (max-width: ${bp.tablet}) {
    max-width: 100%;
    min-width: 0;
    max-height: none;
    width: 100%;
  }
`;

const Badge = styled.div`
  position: absolute;
  top: -5px;
  right: 0;
  background: #374151;
  color: white;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  padding: 5px;
  border-radius: 12px;
  text-transform: uppercase;
`;

const CardImg = styled.img`
  width: 70%;
  height: 40%;
  object-fit: contain;
  margin-bottom: 0.55rem;

  @media (max-width: ${bp.mobile}) {
    width: 55%;
    height: auto;
  }
`;

const CardTitle = styled.h3`
  font-size: 1rem;
  font-weight: 700;
  color: #0a2260;
  margin: 0 0 0.35rem;
`;

const CardDesc = styled.p`
  font-size: 0.9rem;
  color: #6b7280;
  line-height: 1.5;
`;

// ── Sub-components ────────────────────────────────────────────────────────────

function ToolCard({
  title,
  image,
  navigateTo,
  description,
  comingSoon = false,
}) {
  const navigate = useNavigate();
  return (
    <CardWrapper
      $comingSoon={comingSoon}
      onClick={() => !comingSoon && navigate(navigateTo)}
    >
      {comingSoon && <Badge>Under Development</Badge>}
      <CardImg src={image} alt={title} />
      <CardTitle>{title}</CardTitle>
      {description && <CardDesc>{description}</CardDesc>}
    </CardWrapper>
  );
}

// ── Component ────────────────────────────────────────────────────────────────

export default function Home() {
  const [bannerVisible, setBannerVisible] = useState(true);

  return (
    <Page>
      {/* Mobile-only warning — hidden on desktop via CSS */}
      {bannerVisible && (
        <MobileBanner>
          <BannerText>
            <strong>Best viewed on desktop</strong>
            For the best experience with our tools, please open this page on a
            desktop or laptop computer.
          </BannerText>
          <BannerDismiss
            onClick={() => setBannerVisible(false)}
            aria-label="Dismiss"
          >
            ×
          </BannerDismiss>
        </MobileBanner>
      )}

      <WelcomeBanner>
        <IntroText>
          <div style={{ fontSize: 28, fontWeight: 400 }}>
            <b>B</b>ridging <b>O</b>bservations to <b>H</b>ypotheses through{" "}
            <b>E</b>xecutable <b>M</b>odel <b>E</b>ngineering
          </div>
        </IntroText>
      </WelcomeBanner>

      <Sidebar>
        <SideCard style={{ backgroundColor: "#fff" }}>
          <div
            style={{ fontSize: "16px", lineHeight: "1.6", textAlign: "center" }}
          >
            <img
              src={bohemeImg}
              alt="MeLoDy Lab"
              style={{
                width: "100%",
                // height: "160px",
                objectFit: "cover",
                borderRadius: "10px",
                marginBottom: "20px",
              }}
            />
            <div style={{ marginBottom: "16px" }}>
              Welcome to the
              <a
                href="https://www.nmzlab.pitt.edu/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ margin: "0 2px" }}
              >
                MeLoDy Lab
              </a>
              tools.
            </div>
            <div>
              We develop computational methods for knowledge extraction, model
              inference, and analysis.
            </div>
          </div>
        </SideCard>
      </Sidebar>

      <MainContent>
        <Section>
          <ToolGrid $cols={3}>
            {CURRENT_TOOLS.map((tool) => (
              <ToolCard key={tool.title} {...tool} />
            ))}
          </ToolGrid>
        </Section>

        {PIPELINE_TOOLS.length > 0 && (
          <Section>
            <SectionTitle>Under Development</SectionTitle>
            <ToolGrid $cols={4}>
              {PIPELINE_TOOLS.map((tool) => (
                <ToolCard key={tool.title} {...tool} />
              ))}
            </ToolGrid>
          </Section>
        )}
      </MainContent>
    </Page>
  );
}
